// Generated from the TokenTax Icons Figma Final page. Do not edit.
import * as React from 'react';
import type { IconProps } from './types';
import { Ref, forwardRef } from 'react';
const RefetchPrices = ({ size, ...props }: IconProps, ref: Ref<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={size ?? 18}
    height={size ?? 18}
    fill="none"
    viewBox="0 0 18 18"
    ref={ref}
    {...props}
  >
    <path
      stroke="currentColor"
      strokeLinecap="square"
      d="M13.824 4.53a6.673 6.673 0 0 0-9.381.054L2.298 6.728V3.695M15.644 14.614v-3.033l-2.145 2.145a6.673 6.673 0 0 1-9.38.054"
    />
    <path
      stroke="currentColor"
      strokeLinecap="square"
      strokeLinejoin="round"
      d="M9.006 5.63v.953M9.006 11.351v.954M7.576 11.351H9.72a1.192 1.192 0 1 0 0-2.384h-1.43a1.192 1.192 0 1 1 0-2.384h2.146"
    />
  </svg>
);
const ForwardRef = forwardRef(RefetchPrices);
export default ForwardRef;
